import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchNewsItem, fetchNewsList } from "./newsApi";
import { getOrganisationId } from "../organisations/organisationsSlice";
import { catchAllErrors } from "../../hoc/catchAllErrors";

export const fetchNewsAsync = createAsyncThunk("news/fetchNews", async () => {
    const organisationId = await catchAllErrors(getOrganisationId)()
    const response = await fetchNewsList(organisationId);
    return response
});

export const fetchNewsItemAsync = createAsyncThunk("news/fetchNewsItem", async (id) => {
    const organisationId = await catchAllErrors(getOrganisationId)()
    const response = await catchAllErrors(fetchNewsItem)(id, organisationId);
    return response.json();
});

export const newsSlice = createSlice({
    name: "news",
    initialState: {
        news: [],
        meta: {},
        status: "idle",
        error: null,
    },
    reducers: {
        setNews: (state, action) => {
            state.news = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchNewsAsync.pending, (state) => {
                state.news = [];
                state.status = "pending";
            })
            .addCase(fetchNewsAsync.fulfilled, (state, action) => {
                state.news = action.payload;
                state.status = "fulfilled";
            })
            .addCase(fetchNewsAsync.rejected, (state, action) => {
                state.news = [];
                state.status = "rejected";
                state.error = action.error.message;
            })
            .addCase(fetchNewsItemAsync.pending, (state) => {
                state.news = [];
                state.status = "pending";
            })
            .addCase(fetchNewsItemAsync.fulfilled, (state, action) => {
                state.news = state.news.some((news) => news.id === action.payload.data.id)
                    ? state.news.map((news) => (news.id === action.payload.data.id ? action.payload.data : news))
                    : [...state.news, action.payload.data];
                state.status = "fulfilled";
            })
            .addCase(fetchNewsItemAsync.rejected, (state, action) => {
                state.news = [];
                state.status = "rejected";
                state.error = action.error.message;
            });
    },
});

export const { setNews } = newsSlice.actions;

export const selectNews = (state) => state.news.news;
export const selectNewsItem = (state, id) => {
    return state.news.news.find((news) => news.id == id)
};

export default newsSlice.reducer;
